export default {
  title: 'Upload agreement matrix',

  uploadSpace: {
    placeholder: 'Drag and drop the file here',
    placeholderDrag: 'Drag and drop'
  },

  actions: {
    uploadFile: 'Upload file',
    uploadServiceFile: 'Send services matrix',
    uploadProductFile: 'Send products matrix',
    replace: 'Replace'
  },

  uploadHistoryGrid: {
    title: 'Upload history',
    tooltipDownload: 'Download file with format errors',

    headers: {
      date: 'Date',
      file: 'File',
      size: 'Size',
      status: 'Status',
      lastStatusUpdate: 'Last status date',
      actions: 'Actions'
    },

    statuses: {
      uploadPending: 'Loading in progress',
      uploadError: 'Errors in loading',
      uploadComplete: 'Loading complete',
      validationPending: 'Validation in progress',
      validationError: 'Error in validation'
    },
  },

  messages: {
    uploadSuccess: 'The matrix was loaded successfully. Please wait until all configurations are applied. This may take a few minutes',
    formatErrorsFound: 'The file is not valid, its format does not meet the expected requirements',
    invalidTypeFile: 'The file type is invalid',
    downloadError: 'Error downloading the file',
  },
}
